module.exports = __webpack_public_path__ + "img/spectacle.15d7c36f.jpg";